const Footer = () => {
  const currentYear = new Date().getFullYear();
    return <footer className='w-full text-sm mt-8 p-4 bg-slate-200'>
      &copy; {currentYear}, all rights reserved.
     </footer>
}

export default Footer;